import { useEffect, useState } from "react";
import { toast } from "sonner";

const LAUNCH_DATE = new Date("2027-01-01T00:00:00Z");
const MILESTONE_DAYS = [30, 7];

const getTimeLeft = () => {
  const diff = Math.max(0, LAUNCH_DATE.getTime() - Date.now());
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
};

const UNITS = [
  { key: "days", label: "Days" },
  { key: "hours", label: "Hrs" },
  { key: "minutes", label: "Min" },
  { key: "seconds", label: "Sec" },
];

// Live countdown to the January 1, 2027 pre-launch target date, shown on the
// Ambassador Program page in place of the earlier "Coming Soon" teaser.
export const LaunchCountdown = () => {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      const t = getTimeLeft();
      setTimeLeft(t);
      if (MILESTONE_DAYS.includes(t.days) && !localStorage.getItem(`rr_countdown_milestone_${t.days}_shown`)) {
        localStorage.setItem(`rr_countdown_milestone_${t.days}_shown`, "true");
        toast.success(`🚀 Only ${t.days} days until RelayRigs launches!`, { duration: 8000 });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div data-testid="launch-countdown" className="flex items-center justify-center gap-3 md:gap-4">
      {UNITS.map((u) => (
        <div
          key={u.key}
          data-testid={`launch-countdown-${u.key}`}
          className="bg-white/10 border border-white/15 rounded-xl px-3.5 py-2.5 min-w-[64px] text-center"
        >
          <div className="font-heading text-2xl md:text-3xl font-extrabold text-white tabular-nums">
            {String(timeLeft[u.key]).padStart(2, "0")}
          </div>
          <div className="text-[10px] font-bold uppercase tracking-wide text-white/60 mt-0.5">{u.label}</div>
        </div>
      ))}
    </div>
  );
};
